import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import GestionCanales from "../../components/canales/GestionCanales";
import useEventoStore from "../../stores/useEventoStore";
import { ROL } from "../../domain/staff/roles";
import { PADDING_COMO_HEADER } from "../../components/Header";
import { generateEventoUrl } from "../../utils/generateEventoUrl";

const Canales = () => {
  const { id } = useParams();
  const userRole = useEventoStore((state) => state.eventosPorId[id]?.data?.eventoUsuario?.idrol ?? null);
  const evento = useEventoStore((state) => state.eventosPorId[id]?.data?.evento ?? null);

  useEffect(() => {
    document.title = "Canales de venta | PassGo";
  }, []);

  return (
    <Container maxWidth="lg" sx={PADDING_COMO_HEADER}>
      <GestionCanales
        eventoId={id}
        rutaEvento={evento ? generateEventoUrl(evento) : `/evento/${id}/informacion`}
        puedeEditar={userRole === ROL.OWNER}
      />
    </Container>
  );
};

export default Canales;
